import { render, staticRenderFns } from "./NotificationListMaintain.vue?vue&type=template&id=204f9d24"
import script from "./NotificationListMaintain.vue?vue&type=script&lang=js"
export * from "./NotificationListMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports